import { ActionReducer, MetaReducer } from '@ngrx/store';
import { utilLocalStorageReducer } from '@medlogic/shared/utils';
import { FrailtyActionTypes } from './frailty.actions';
import { initialState } from './frailty.reducer';

const KEY = 'MEDLOGIC_FRAILTY_STATE';

// Includes the action types that must be persisted.
const PERSISTED_ACTIONS: string[] = [
  FrailtyActionTypes.LoadFrailtys
];

export function localStorageReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return utilLocalStorageReducer(reducer, PERSISTED_ACTIONS, KEY, initialState);
}

export const metaReducers: MetaReducer<any>[] = [localStorageReducer];
